import { PORTAL_API_NAMES, PORTAL_AUTOMATION_ROUTES } from './constants';
import WorkflowListPage from './WorkflowListPage';

// Portal-automation runs are integration-created, so no New button.
// Shows both portal work types in one table (OLIO-2758): retrieval runs anchored to a referral
// and discovery sweeps anchored to a portal. PORTAL_API_NAMES is module-level so the identity is
// stable across renders and the list's filter memo isn't invalidated every time.
export default function PortalAutomationListPage() {
  return (
    <WorkflowListPage title='Portal Automation' apiNames={PORTAL_API_NAMES} basePath={PORTAL_AUTOMATION_ROUTES.BASE} />
  );
}
